import { UPDATE_SELECTED_TAGS, RESET_FILTER } from "../actions/tagFilter";

const initialState = {
  selectedTags: [],
  filter: {
    operator: "in",
    property_name: "sending_tag",
    property_value: []
  }
};

const tagFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_FILTER:
      return {
        ...state,
        selectedTags: [],
        filter: {
          operator: "in",
          property_name: "sending_tag",
          property_value: []
        }
      };
    case UPDATE_SELECTED_TAGS:
      return {
        ...state,
        selectedTags: action.payload,
        filter: {
          operator: "in",
          property_name: "sending_tag",
          property_value: action.payload
        }
      };
    default:
      return state;
  }
};

export default tagFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/tagFilterReducer.js